import BaseView from "../views/BaseView";
import { DisplayObject } from "pixi.js";
import ConsoleUtil from "../utils/ConsoleUtil";

export class UIBehaviourPattern {
    protected uiToEnable: BaseView[];
    protected uiToDisable: BaseView[];
    protected uiToHide: DisplayObject[];
    protected uiToShow: DisplayObject[];
    protected uiToEnableMask: BaseView[];
    protected uiToDisableMask: BaseView[];
    protected uiToHideMask: DisplayObject[];
    protected uiToShowMask: DisplayObject[];

    constructor(pattern: IBehaviourPattern) {
        this.uiToEnable = pattern.uiToEnable || [];
        this.uiToDisable = pattern.uiToDisable || [];
        this.uiToHide = pattern.uiToHide || [];
        this.uiToShow = pattern.uiToShow || [];
        this.uiToEnableMask = [];
        this.uiToDisableMask = [];
        this.uiToHideMask = [];
        this.uiToShowMask = [];
    }

    public addMask(pattern: IBehaviourPattern) {
        this.uiToEnableMask = pattern.uiToEnable || [];
        this.uiToDisableMask = pattern.uiToDisable || [];
        this.uiToHideMask = pattern.uiToHide || [];
        this.uiToShowMask = pattern.uiToShow || [];
    }

    public executePattern() {
        this.uiToEnable.forEach(element => {
            if(this.uiToEnableMask.indexOf(element) ==-1) {
                if (element) {
                    element.setEnabled(true);
                } else {
                    ConsoleUtil.warn("[UI] MISSING UI ELEMENT -> this.uiToEnable");
                }
            }
        });

        this.uiToDisable.forEach(element => {
            if(this.uiToDisableMask.indexOf(element) ==-1) {
                if (element) {
                    element.setEnabled(false);
                } else {
                    ConsoleUtil.warn(
                        "[UI] MISSING UI ELEMENT -> this.uiToDisableMask"
                    );
                }
            }
        });

        this.uiToHide.forEach(element => {
            if(this.uiToHideMask.indexOf(element) ==-1) {
                if (element) {
                    element.visible = false;
                } else {
                    ConsoleUtil.warn(
                        "[UI] MISSING UI ELEMENT -> this.uiToHideMask"
                    );
                }
            }
        });

        this.uiToShow.forEach(element => {
            if(this.uiToShowMask.indexOf(element) ==-1) {
                if (element) {
                    element.visible = true;
                } else {
                    ConsoleUtil.warn(
                        "[UI] MISSING UI ELEMENT -> this.uiToShowMask"
                    );
                }
            }
        });
    }
}

export interface IBehaviourPattern {
    uiToEnable?: BaseView[];
    uiToDisable?: BaseView[];
    uiToHide?: DisplayObject[];
    uiToShow?: DisplayObject[];
}